import script from "./LanguageDropdownSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./LanguageDropdownSelector.vue?vue&type=script&lang=ts&setup=true"

import "./LanguageDropdownSelector.vue?vue&type=style&index=0&id=bf70321c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf70321c"]])

export default __exports__